import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import Yup from 'yup';
import MainTitle from 'base/components/MainTitle/index';
import SubmitButton from 'base/components/forms/SubmitButton';
import FormikInputField from 'base/components/forms/formik/FormikInputField';
import { getActiveTag } from 'documents/store/tags/selectors';
import { updateTag } from 'documents/store/tags/actions';
import { closeModal } from 'modal/store/actions';


const EditTagForm = ({errors, isSubmitting}) => ( // eslint-disable-line
  <Form>
    <Field
      type="text"
      name="name"
      placeholder="Name"
      component={FormikInputField}
      autoFocus
    />
    <SubmitButton type="submit" disabled={isSubmitting}>
        Update Tag
    </SubmitButton>
  </Form>
);


const UpdateTagModal = ({
  name, tag, updateTag, closeModal,
}) => (
  <>
    <MainTitle withSpaceBelow>Edit Tag</MainTitle>

    <Formik
      initialValues={{
        name: tag.name,
      }}
      validationSchema={
            Yup.object().shape({
              name: Yup.string()
                .required('Name is required.'),
            })
          }
      render={EditTagForm}
      onSubmit={(values) => {
        const updatedTag = {
          ...tag,
          name: values.name,
        };
        updateTag(updatedTag);
        closeModal(name);
      }}
    />
  </>
);
UpdateTagModal.propTypes = {
  name: PropTypes.string.isRequired,
  tag: PropTypes.object.isRequired, // eslint-disable-line
  updateTag: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  tag: getActiveTag(state),
});


const mapDispatchToProps = {
  updateTag,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateTagModal);
